import React, { useEffect, useState,useRef,useCallback } from "react";
import { getAccountStatus } from "../../../services/ApiService";
import LoadingSpinner from "../../../components/client/LoadingSpinner";
import instagram_ads_icon from "../../../assests/instagram.png";
import twitter from "../../../assests/twitter.svg";
import bing from "../../../assests/bing.svg";
import snapchat from "../../../assests/snapchat.svg";
import linkedin from "../../../assests/linkedin.png";
import semrush from "../../../assests/semrush.png";
import facebook_ads_icon from "../../../assests/facebook.png";
import GoogleAdsIntegration from "../../../components/client/integrations/google_ads_integrations/GoogleAdsIntegration";
import AdsCard from "../../../components/client/integrations/AdsCard";
import LinkedInAdsIntegration from "../../../components/client/integrations/Linkedin_ads_integration/LinkedInAdsIntegration";
import SnapchatAdsIntegration from "../../../components/client/integrations/snapchat_ads_integration/SnapchatAdsIntegration";
import SpotifyAdsIntegration from "../../../components/client/integrations/spotify_ads_integration/SpotifyAdsIntegration";
import GoogleAnalyticsIntegration from "../../../components/client/integrations/google_analytics_integration/GoogleAnalyticsIntegration";
import FacebookAdsIntegartion from "../../../components/client/integrations/facebook_ads_integration/FacebookAdsIntegartion";
import { handleApi } from "../../../utils/authentication";

//integration
import InstagramAdsIntegration from "../../../components/client/integrations/instagram_ads_integration/InstagramAdsIntegration";
import { useSelector } from "react-redux";
import { integrations } from "../client-tour/integrations";
import useClientTour from "../../../hooks/useClientTour";


const Integrations = () => {
  const [accountLinkedStatus, setAccountLinkedStatus] = useState({});
  const [loadingAdsAccStatus, setLoadingAdsAccStatus] = useState(true);
  const user = useSelector((state) => state?.user);
  const filterState = useSelector((state) => state?.filter);
  const filter = filterState && filterState?.filter_platform ? filterState : { filter_platform: { value: 'all', label: 'All' } }
  const tour = useSelector((state) => state?.tour);

  useClientTour({
    enabled: !user?.has_seen_tour && !tour?.integration_page && user?.is_client,
    steps: integrations,
    tourKey: "integration_page",
    nextRoute: "/client/dashboards/home",
    skipRoute: "/client/settings/integrations",
  });



  // Function to fetch ads account status
  const fetchAdsAccountStatus = useCallback(async () => {
    try {
      setLoadingAdsAccStatus(true);
      const result = await getAccountStatus();

      if (result?.success) {
        setAccountLinkedStatus(result?.platforms); // Update state with the linked accounts
      }
    } catch (error) {
      console.error("Error fetching ads account status:", error);
    } finally {
      setLoadingAdsAccStatus(false); // Turn off loading indicator
    }
  },[])

  // const updateApplicationTourStatus = async () => {
  //   try {

  //     const formData = new FormData()
  //     formData.append('user_id', user?.user_id)
  //     formData.append('client_id', user?.client_id)
  //     formData.append('has_seen_tour', user?.has_seen_tour)
  //     let result = await handleApi('update_application_tour_status', 'POST', {}, formData)
  //     if (result?.success) {
  //       dispatch(UPDATE_USER_DATA({
  //         has_seen_tour: result?.data?.has_seen_tour
  //       }))
  //     }

  //   } catch (e) {
  //     console.log(e)
  //   }

  // }

  // Call fetchAdsAccountStatus on component mount
  useEffect(() => {
    fetchAdsAccountStatus();
  }, [fetchAdsAccountStatus]);



  return (
    <>
      {loadingAdsAccStatus ? (
        <LoadingSpinner />
      ) : (
        <div className="d-flex flex-column gap_lg platform_list">
          <div className="row row-cols-1 row-cols-md-2  row-cols-xl-3 g-4 ">
            {((filter?.filter_platform?.value === "organic_social") || (filter?.filter_platform?.value === "all")) && (
                <>
                  <div className="col">
                    <FacebookAdsIntegartion
                      isAccountLinked={
                        accountLinkedStatus?.facebook_posts?.is_account_linked && accountLinkedStatus?.facebook_posts?.is_posts_connected
                      }
                      setAccountLinkedStatus={setAccountLinkedStatus}
                      accountDetails={accountLinkedStatus?.facebook_posts}
                      fetchAdsAccountStatus={fetchAdsAccountStatus}
                      social_media_type="organic_social"
                    />
                  </div>
                  <div className="col">
                    <LinkedInAdsIntegration
                      isAccountLinked={
                        accountLinkedStatus?.linkedin_ads?.is_account_linked && accountLinkedStatus?.linkedin_ads?.is_posts_connected
                      }
                      accountDetails={accountLinkedStatus?.linkedin_ads}
                      fetchAdsAccountStatus={fetchAdsAccountStatus}
                      social_media_type="organic_social"
                    />
                  </div>
                  <div className="col">
                  <InstagramAdsIntegration
                    isAccountLinked={
                      accountLinkedStatus?.instagram_ads?.is_account_linked  && accountLinkedStatus?.instagram_ads?.is_posts_connected
                    }
                    accountDetails={accountLinkedStatus?.instagram_ads}
                    fetchAdsAccountStatus={fetchAdsAccountStatus}
                    social_media_type="organic_social"
                  />
                  </div>
                </>
              )}
            {((filter?.filter_platform?.value === "paid_social") ||  (filter?.filter_platform?.value === "all")) && (
                <>
                  <div className="col">
                    <FacebookAdsIntegartion
                      isAccountLinked={
                        accountLinkedStatus?.facebook_ads?.is_account_linked && accountLinkedStatus?.facebook_ads?.is_ads_connected
                      }
                      accountDetails={accountLinkedStatus?.facebook_ads}
                      fetchAdsAccountStatus={fetchAdsAccountStatus}
                      social_media_type="paid_social"
                    />
                  </div>
                  <div className="col">
                 <LinkedInAdsIntegration
                      isAccountLinked={
                        accountLinkedStatus?.linkedin_ads?.is_account_linked && accountLinkedStatus?.linkedin_ads?.is_ads_connected
                      }
                      accountDetails={accountLinkedStatus?.linkedin_ads}
                      fetchAdsAccountStatus={fetchAdsAccountStatus}
                      social_media_type="paid_social"
                    /> 
                  </div>
                  
                  <div className="col">
                    <SnapchatAdsIntegration
                      isAccountLinked={
                        accountLinkedStatus?.snapchat_ads?.is_account_linked
                      }
                      accountDetails={accountLinkedStatus?.snapchat_ads}
                      fetchAdsAccountStatus={fetchAdsAccountStatus}
                    />
                  </div>
                </>
              )}
            {((filter?.filter_platform?.value === "paid_media") || (filter?.filter_platform?.value === "all")) && (
                <>
                  <div className="col">
                    <GoogleAdsIntegration
                      isAccountLinked={
                        accountLinkedStatus?.google_ads?.is_account_linked && accountLinkedStatus?.google_ads?.is_ads_connected
                      }
                      accountDetails={accountLinkedStatus?.google_ads}
                      fetchAdsAccountStatus={fetchAdsAccountStatus}
                      social_media_type={accountLinkedStatus?.google_ads?.is_ads_connected ? 'paid_social' : ''}
                    />
                  </div>
                  <div className="col">
                    <SpotifyAdsIntegration
                      isAccountLinked={
                        accountLinkedStatus?.spotify_ads?.is_account_linked
                      }
                      accountDetails={accountLinkedStatus?.spotify_ads}
                      fetchAdsAccountStatus={fetchAdsAccountStatus}
                      social_media_type={accountLinkedStatus?.spotify_ads?.is_ads_connected ? 'paid_social' : ''}
                    />
                  </div>
                  <div className="col">
                    <AdsCard
                      apiData={{}}
                      disabled={true}
                      handleConnect={() => { }}
                      isAccountLinked={false}
                      clientData={{}}
                      platform={"Bing Ads"}
                      platform_icon={bing}
                      description={
                        "Bing Ads is Microsoft's advertising platform that allows businesses to create and manage pay-per-click campaigns to reach a wide audience."
                      }
                    />
                  </div>
                </>
              )}
            {((filter?.filter_platform?.value === "owned_media") || (filter?.filter_platform?.value === "all") ) && (
                <>
                  {/* google analytics */}
                  <div className="col">
                    <GoogleAnalyticsIntegration
                      isAccountLinked={
                        accountLinkedStatus?.google_analytics?.is_account_linked
                      }
                      accountDetails={accountLinkedStatus?.google_analytics}
                      fetchAdsAccountStatus={fetchAdsAccountStatus}
                      social_media_type="owned_media"
                    />
                  </div>
                </>
              )}
            {((filter?.filter_platform?.value === "search") || (filter?.filter_platform?.value === "all")) && (
                <>
                  {/* google analytics */}
                  <div className="col">
                    <AdsCard
                      apiData={{}}
                      disabled={true}
                      handleConnect={() => { }}
                      isAccountLinked={false}
                      clientData={{}}
                      platform={"Semrush"}
                      platform_icon={semrush}
                      description={
                        "Semrush is an all-in-one online marketing platform that provides businesses with tools for SEO, content marketing, competitor research, PPC, and social media marketing."
                      }
                    />
                  </div>
                </>
              )}


          </div>
        </div>
      )}
    </>
  );
};

export default Integrations;
